import React from 'react'
import './Catalogo.css'

function Catalogo({id, image,title,color}) {
    return (
        <div className="catalogo">
            <span className="dot" style={{backgroundColor:color}}>
            <img className= "catalogo_image" src={image} />
      
        <div className="catalogo_info">
            <p className="catalogo_title">{title}</p>
        
                 </div>
                 </span>
                 </div>
                 
    )
}

export default Catalogo
